import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    personalityAspectId: '',
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    personalityAspectId: (state) => state.personalityAspectId,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
      state.personalityAspectId = recordsData?.personalityAspectId ? recordsData.personalityAspectId : '';
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([apiClient.caxARPxPersonalitySchema()]);

        const [schemaRes] =
          responses.map((res) => res?.data ?? {});

        let id2 = 'D';
        const resCat2 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionD = resCat2.data.data;

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');

        let schema = structuredClone(schemaRes);
        schema.schemaFormItems[2].schemaForm.group4.schema.i1_personality_identity_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[2].schemaForm.group4.schema.i2_personality_identity_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[2].schemaForm.group4.schema.i3_personality_identity_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[2].schemaForm.group4.schema.i4_personality_identity_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[2].schemaForm.group4.schema.i5_personality_identity_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[2].schemaForm.group4.schema.i6_personality_identity_level_description_id.items =
          catLevelDescriptionD;

        let modelFormItems = [
          { modelForm: { group1: {}, group2: {} } },
          { modelForm: { group1: {}, group2: {} } },
          { modelForm: { group1: {}, group2: {}, group3: {}, group4: {}, group5: {} } },
        ];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxARPxPersonality(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        if (recordsData.isNewRecord === true) {
          modelSlides.cognitive_attention_id =
            dataModelFormItems[0].modelForm.cognitive_attention_id;
        }

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxARPxPersonality(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = model.personalityAspectId;
        await apiClient.updateCAxARPxPersonality(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
